const openSuccessModal = () => {

    const successModal = document.querySelector('#modal-success');
    const modalFeedback = document.querySelector('#modal-feedback');
    
    $(".form").submit(function (e) { // Устанавливаем событие отправки для формы с id=form
        e.preventDefault();
         let form_data = $(this).serialize(); // Собираем все данные из формы
         $.ajax({
             type: "POST", // Метод отправки
             url: "/wp-content/themes/yuvin/assets/build/send.php", // Путь до php файла отправителя
             data: form_data,
             success: function () {
                 // Код в этом блоке выполняется при успешной отправке сообщения
                 modalFeedback.close();
                 successModal.showModal();
             }
         });
    });

    const search = document.querySelector('.dgwt-wcas-search-form');

      $(".dgwt-wcas-search-form").submit(function (e) { // Устанавливаем событие отправки для формы с id=form
        e.preventDefault();
      });
}
export default openSuccessModal;

